import { Capacitor } from '@capacitor/core'
import { Keyboard, KeyboardInfo } from '@capacitor/keyboard'
import { signal } from '@preact/signals-react'
import { SafeArea, SafeAreaInsets } from 'capacitor-plugin-safe-area'

/// ˅˅˅ SIGNELS

type TWindowSize = {
    insets: SafeAreaInsets | undefined
    /// Guesture controls take up less room and we can show stuff behind them. Buttons, less so, footer/navbar needs context of this... (ios never has buttons, fyi.)
    navBarBottom: 'guestureIos' | 'guestureAndroid' | 'buttonBlock' | 'webView'
}

type TKeyboardInfoState = {
    info?: KeyboardInfo
    openState: 'didHide' | 'willHide' | 'didShow' | 'willShow'
}

export const keyboardState = signal<TKeyboardInfoState>({
    info: undefined,
    openState: 'didHide',
})

export const backgroundImageUrl = signal<string>('')

export const windowSizes = signal<TWindowSize>({
    insets: { insets: { top: 0, left: 0, right: 0, bottom: 0 } },
    navBarBottom: 'webView',
})

/// ^^^ SIGNELS

/// ˅˅˅ LISTERNERS

if (Capacitor.isNativePlatform()) {
    Keyboard.addListener('keyboardWillShow', (info) => {
        // console.log('keyboard will show with height:', info.keyboardHeight)
        keyboardState.value = { info: info, openState: 'willShow' }
    })

    Keyboard.addListener('keyboardDidShow', (info) => {
        // console.log('keyboard did show with height:', info.keyboardHeight)
        keyboardState.value = { info: info, openState: 'didShow' }
    })

    Keyboard.addListener('keyboardWillHide', () => {
        // console.log('keyboard will hide')
        keyboardState.value = {
            info: keyboardState.peek().info,
            openState: 'willHide',
        }
    })

    Keyboard.addListener('keyboardDidHide', () => {
        // console.log('keyboard did hide')
        keyboardState.value = {
            info: keyboardState.peek().info,
            openState: 'didHide',
        }
    })
} else {
    keyboardState.value = { info: undefined, openState: 'didHide' }
}

if (Capacitor.isNativePlatform()) {
    SafeArea.getSafeAreaInsets().then((insets) => {
        if (insets) {
            windowSizes.value = {
                insets: insets,
                navBarBottom:
                    Capacitor.getPlatform() === 'ios'
                        ? 'guestureIos'
                        : insets.insets.bottom > 30
                            ? 'buttonBlock'
                            : 'guestureAndroid',
            }
        }
    })

    SafeArea.removeAllListeners()
    SafeArea.addListener('safeAreaChanged', (insets) => {
        if (insets) {
            windowSizes.value = {
                insets: insets,
                navBarBottom:
                    Capacitor.getPlatform() === 'ios'
                        ? 'guestureIos'
                        : insets.insets.bottom > 30
                            ? 'buttonBlock'
                            : 'guestureAndroid',
            }
        }
    })
} else {
    // Not native
    windowSizes.value = {
        insets: { insets: { top: 0, left: 0, right: 0, bottom: 0 } },
        navBarBottom: 'webView',
    }
}
/// ^^^ LISTERNERS
